module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"oracleCloudAccountsTable.tenancyId":"Tenancy ID","oracleCloudAccountsTable.userId":"User ID","oracleCloudAccountsTable.noData":"No oracle cloud connections configured.","oracleCloudAccountsTable.disconnectedUsageConnection":"Please update your usage connection with valid credentials"}}')
  delete Component.options._Ctor
}
